export default __webpack_public_path__ + "pin-small.1fd48969aa61449a.svg";